import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChildren,
  effect,
  input,
  output,
  signal,
} from "@angular/core";

import { LinkComponent } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

import { OnboardingTaskComponent } from "./onboarding-task.component";

@Component({
  selector: "app-onboarding",
  templateUrl: "./onboarding.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LinkComponent, I18nPipe],
})
export class OnboardingComponent implements AfterContentInit {
  readonly tasks = contentChildren(OnboardingTaskComponent);
  readonly title = input.required<string>();

  readonly dismiss = output<void>();

  protected readonly open = signal(true);

  protected readonly amountCompleted = computed(
    () => this.tasks().filter((task) => task.completed()).length,
  );

  protected readonly progressPercent = computed(() => {
    const total = this.tasks().length;
    if (total === 0) {
      return 0;
    }
    return (this.amountCompleted() / total) * 100;
  });

  constructor() {
    effect(() => {
      const tasks = this.tasks();
      const firstIncompleteIndex = tasks.findIndex((task) => !task.completed());
      tasks.forEach((task, index) => {
        task.setActive(index === firstIncompleteIndex);
      });
    });
  }

  ngAfterContentInit(): void {
    this.open.set(this.amountCompleted() <= 1);
  }
}
